define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"SiteAdmin/AttributeMap/AttributeMapTable"
], function(declare,_,AttributeMapTable) {

	var SETTINGS_URL = "centric://REFLECTION/INSTANCE/ColorColorwayContextConfig/Settings";
	var SETUP_SETTINGS_URL = "centric://REFLECTION/INSTANCE/ColorColorwayContextConfig/SetupSettings";
	var MAP_SETTING_ID = "ColorwayAttributeMap";
	var MAP_ENTRY_NODE_TYPE = "_ColorwayAttributeMapEntry_";
	var DEST_ATTR_ID_ATTR = "ColorwayAttributeId";

	AttributeMapTable.watchValueDropDown(MAP_ENTRY_NODE_TYPE, DEST_ATTR_ID_ATTR);

	return declare(AttributeMapTable, {
		settingsUrl: SETTINGS_URL,
		setupSettingsUrl: SETUP_SETTINGS_URL,
		mapSettingId: MAP_SETTING_ID,
		mapEntryNodeType: MAP_ENTRY_NODE_TYPE,
		destAttrIdAttr: DEST_ATTR_ID_ATTR,
		sourceClassName: "ColorColorwayContext"

	});
});
